import React from 'react';
import ProfileCard from '../ProfileCard';
import ServicesCard from '../ServicesCard';
import WorkingHoursCard from '../WorkingHoursCard';
import BookingRestrictions from 'pages/dashboard/CalendarSettingPage/components/AviabilityPage/BookingRestrictions';
import BookingTimeIncrements from 'pages/dashboard/CalendarSettingPage/components/AviabilityPage/BookingTimeIncrements';
import MinimumTimeCard from '../MinimumTimeCard';
import { useSwitchedProvider } from '../../SwitchedProviderContext';
import s from './s.module.less';

interface Props {
    provider: any;
}

const PracticeSetupTab: React.FC<Props> = ({ provider }) => {
    const { scheduleToken, onRefresh, bordered } = useSwitchedProvider();

    const profileInitValue = provider
        ? {
              firstName: provider.firstName,
              lastName: provider.lastName,
              credential: provider.credential,
              gender: provider.gender,
          }
        : null;

    return (
        <div className={s.wrap}>
            <ProfileCard initValue={profileInitValue} />
            <ServicesCard initValue={provider?.services || null} />
            <WorkingHoursCard initValue={provider?.availability || null} />
            <BookingRestrictions
                value={provider?.reminderSettings || undefined}
                scheduleToken={scheduleToken}
                onUpdate={() => onRefresh?.()}
                bordered={bordered}
            />
            <div className='mt-6'>
                <MinimumTimeCard initValue={provider?.reminderSettings || null} />
            </div>
            <BookingTimeIncrements
                value={provider?.reminderSettings || undefined}
                scheduleToken={scheduleToken}
                onUpdate={() => onRefresh?.()}
                bordered={bordered}
            />
        </div>
    );
};

export default PracticeSetupTab;
